/** Окно «Kling, скорее всего, откажет — всё равно создать?» перед запуском Kling Motion Control (калибровка 12.10):
 *  промис для запуска и связь с хостом (components/MotionRiskConfirm). Подсказка, а не запрет: клиент решает сам. */

export interface PendingRisk {
	text: string
}

let show: ((pending: PendingRisk | null) => void) | null = null
let current: { text: string; resolve: (go: boolean) => void } | null = null

/** true — создавать. Хост не смонтирован — true: подсказка не должна держать запуск. Окно уже открыто (двойное нажатие
 *  «Создать») — второй запуск не ждёт, а отменяется. */
export function confirmMotionRisk(text: string): Promise<boolean> {
	if (!show) return Promise.resolve(true)
	if (current) return Promise.resolve(false)
	const open = show
	return new Promise<boolean>((resolve) => {
		current = { text, resolve }
		open({ text })
	})
}

/** Ответ из окна: закрывает его и отпускает запуск. */
export function settleMotionRisk(go: boolean): void {
	current?.resolve(go)
	current = null
	show?.(null)
}

/** Хост встал на страницу; возвращает снятие (ждущий запуск тогда идёт дальше). */
export function attachMotionRiskHost(setter: (pending: PendingRisk | null) => void): () => void {
	show = setter
	return () => {
		if (show === setter) show = null
		current?.resolve(true)
		current = null
	}
}
